$(document).ready(function() {
  let showWords = 250,
    ellipsis = "…",
    readMore = "Lire plus",
    readLess = "Lire moins";


  $(".js-read-more").each(function() {
    let contentWords = $(this).html();
    if(contentWords.length > showWords) {

      let c = contentWords.substring(0, showWords),
        h = contentWords.substring(showWords, contentWords.length),

        html = c + '<span class="moreellipses">' + ellipsis + '</span><span class="morecontent" style="display: none;">' + h + '</span><a href="" class="js-read-more-link">' + readMore + '</a>';

      $(this).html(html);
    }

  });

  $(".js-read-more-link").click(function(){
    if($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(readMore);
    } else {
      $(this).addClass("less");
      $(this).html(readLess);
    }
    $(this).prev().prev().toggle();
    $(this).prev().toggle();
    return false;
  });
});
